export const getCarValues = (keyValue, statData) => {
  let item = statData[keyValue];
  switch (keyValue) {
    case "budget":
      return {
        title: "Total Budget",
        icon: "bi bi-coin",
        iconClass: "text-primary",
        total: item?.total,
        progress: [
          {
            leftLabel: `Spent ${item.burn_p || 0}%`,
            rightLabel: `Remaining ${(100 - (item.burn_p || 0)).toFixed(2)}%`,
            percent: item.burn_p,
            leftValue: item.burn_a,
            rightValue: item.remaining,
          },
          {
            leftLabel: `Invoiced ${statData["revenue"].earning_p || 0}%`,
            rightLabel: `Remaining ${(
              100 - (statData["revenue"].earning_p || 0)
            ).toFixed(2)}%`,
            percent: statData["revenue"].earning_p,
            leftValue: statData["revenue"].invoiced,
            rightValue: statData["revenue"].pending,
          },
        ],
      };
    case "burn":
      return {
        title: "Project Work in Progress",
        icon: "bi bi-fire",
        iconClass: "text-warning",
        total: item.total,
        rows: [
          { label: "Worked:", value: item.worked },
          { label: "Expenses:", value: item.expenses },
        ],
        progress: [
          {
            leftLabel: `Spent ${item.burn_p}%`,
            rightLabel: `Remaining ${(100 - (item.burn_p || 0)).toFixed(2)}%`,
            percent: item.burn_p,
            leftValue: item.total,
            rightValue: item.remaining,
          },
        ],
        statusText: item.burn_text,
      };
    case "revenue":
      return {
        title: "Project Invoice Summary",
        icon: "bi bi-file-bar-graph-fill",
        iconClass: "text-success",
        total: item?.total,

        rows: [
          { label: "Invoiced:", value: item?.invoiced },
          { label: "Remaining Forecast:", value: item?.remaining },
        ],

        progress: [
          {
            leftLabel: `Earnings ${item?.earning_p}%`,
            rightLabel: `Remaining ${(100 - (item?.earning_p || 0)).toFixed(
              2
            )}%`,
            percent: item?.earning_p,
            leftValue: item?.total,
            rightValue: item?.pending,
          },
        ],

        statusText: item?.revenue_text,
      };
    default:
      break;
  }
};

const getProgressColorClass = (percent) => {
  if (percent <= 50) return "bg-success"; // Green
  if (percent <= 80) return "bg-warning"; // Yellow
  return "bg-danger"; // Red
};

const ProjectStatsCard = ({
  keyValue,
  icon,
  iconClass,
  title,
  total,
  rows = [],
  progress,
  statusText,
  formatCurrency,
}) => (
  <div className="col-12 col-md mb-4">
    <div className="card custom-card">
      <div className="card-body">
        {keyValue === "budget" ? (
          <div className="d-flex align-items-center budget-header">
            <i className={`${icon} ${iconClass}`} />
            <span className="ms-2 mb-0">{title}</span>
            <h2 className="total-budget-amount">{formatCurrency(total)}</h2>
          </div>
        ) : (
          <>
            <div className="d-flex align-items-center budget-header">
              <i className={`${icon} ${iconClass}`} />
              <span className="ms-2 mb-0">{title}</span>
            </div>
            <div className="budget-total-row">
              <span>Total:</span>
              <span>{formatCurrency(total)}</span>
            </div>
          </>
        )}
        <hr />

        {rows.map((row, i) => (
          <div className="budget-summary-row" key={i}>
            <span>{row.label}</span>
            <span>{formatCurrency(row.value)}</span>
          </div>
        ))}
        <div className="budget-summary-bottom-row">
          {progress &&
            progress.map((pro, idx) => (
              <>
                <div className="budget-summary-row fs-12">
                  <span>{pro.leftLabel}</span>
                  <span>{pro.rightLabel}</span>
                </div>

                <div className="progress budget-progress">
                  <div
                    className={`progress-bar ${getProgressColorClass(
                      pro.percent
                    )}`}
                    style={{ width: `${pro.percent}%` }}
                  />
                </div>

                <div className="budget-summary-row fs-12">
                  <span>{formatCurrency(pro.leftValue)}</span>
                  <span>{formatCurrency(pro.rightValue)}</span>
                </div>

                {statusText && <div className="status-pill">{statusText}</div>}
                {idx < progress.length - 1 && <hr className="hr-dashed" />}
              </>
            ))}
        </div>
      </div>
    </div>
  </div>
);

export default ProjectStatsCard;
